let config = {
    endpoints: {
        backend: 'https://prod-backend.pcontas.com/'
    },
    integration: {
        governanceroom: 'https://prod-backend.saladegestao.com/'
    }
}
export default config;
